import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import PaginaInicial from '@/views/PaginaInicial';
import NotFoundPage from '@/views/utils/NotFoundPage';
import AccessDeniedPage from '@/views/utils/AccessDeniedPage';
import ServerErrorPage from '@/views/utils/ServerErrorPage';

const AppRoutes = [
  {
    path: '/inicio',
    meta: {
      requiresAuth: true,
    },
    name: 'Inicio',
    component: PaginaInicial,
  },
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404',
    },
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: NotFoundPage,
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: AccessDeniedPage,
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: ServerErrorPage,
  },
  {
    path: '/logout',
    meta: {
      requiresAuth: true,
    },
    name: 'Logout',
    beforeEnter() {
      Sentry.configureScope((scope) => scope.setUser(null));
      Vue.$keycloak.logout({ redirectUri: window.location.origin });
    },
  },
  {
    path: '/',
    beforeEnter: (to, from, next) => {
      if (Vue.$keycloak.authenticated) {
        next('/inicio');
      }
      Vue.$keycloak.login({ scope: 'id_institucional' });
    },
  },
];

export default AppRoutes;
